import { useState, useEffect } from 'react'
import { SelectFolder } from '../SelectFolder'

export const CreateFolder = ({ isOpen, onClose, folders = [], onCreated }) => {
	const companyId = JSON.parse(localStorage.getItem('user')).id
	const [name, setName] = useState('')
	const [selectedFolder, setSelectedFolder] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		if (!isOpen) {
			setName('')
			setSelectedFolder(null)
			setError('')
		}
	}, [isOpen])

	const foldersWithInicio = [{ id: 'inicio', name: 'Inicio', parentId: null }, ...folders]

	const handleCreate = async () => {
		if (!name.trim()) {
			setError('Nombre obligatorio')
			return
		}
		setLoading(true)
		setError('')
		try {
			const body = {
				name: name,
				companyId: companyId,
				parentId: selectedFolder === 'inicio' ? null : selectedFolder,
			}
			;(await onCreated) && onCreated(body)
			onClose()
		} catch (e) {
			setError('Error al crear carpeta')
		} finally {
			setLoading(false)
		}
	}

	const isValid = name.trim()

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-6 tw-w-[450px] tw-relative'>
				<div className='tw-text-lg tw-font-medium tw-mb-6'>Crear nueva carpeta</div>
				<div className='tw-mb-4'>
					<label className='tw-block tw-font-bold tw-mb-1'>Nombre de la carpeta</label>
					<input className='border tw-rounded-lg tw-px-3 tw-py-2 tw-w-full' value={name} onChange={e => setName(e.target.value)} disabled={loading} />
				</div>
				<div className='tw-mb-4'>
					<label className='tw-block tw-font-bold tw-mb-1'>Ubicación de la nueva carpeta</label>
					<SelectFolder folders={foldersWithInicio} onSelect={setSelectedFolder} selectedFolder={selectedFolder} />
				</div>
				{/* {error && <div className='tw-text-red-500 tw-mb-2'>{error}</div>} */}
				<div className='tw-flex tw-justify-end tw-gap-3'>
					<div
						onClick={onClose}
						className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
						disabled={loading}
					>
						Cancelar
					</div>
					<div
						onClick={handleCreate}
						className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg ${
							!isValid || loading ? 'tw-opacity-50 tw-cursor-not-allowed' : ''
						}`}
						disabled={!isValid || loading}
						style={{ pointerEvents: !isValid || loading ? 'none' : 'auto' }}
					>
						{loading ? 'Creando...' : 'Crear carpeta'}
					</div>
				</div>
			</div>
		</div>
	)
}

export default CreateFolder
